import { createApiV2 } from "../common";

export const getOrders = (filters) => (token) =>
  createApiV2("POST", "orders/search")(token, filters);

export const getOrderDetails = (uid) => (token) =>
  createApiV2("GET", `planner/orders/${uid}/details/`)(token);

export const getOrder =
  ({ orderUid, customerUid }) =>
  () =>
    createApiV2("GET", `customers/${customerUid}/orders/${orderUid}/`)();

export const getAllStatuses = () => () => createApiV2("GET", `status/`)();

export default {};
